export const PROFILES_ACTION = {
  DATA_LOADING: 'PROFILES_DATA_LOADING',
  DATA_LOADED: 'PROFILES_DATA_LOADED',
  SAVE: 'PROFILES_SAVE',
  UPDATE_LOCALE: 'PROFILES_UPDATE_LOCALE',
  LOAD_PREFERENCES: 'PROFILES_LOAD_PREFERENCES',
  LOAD_BY_ID: 'PROFILES_LOAD_BY_ID',
  UPDATE_PLATFORM: 'PROFILES_UPDATE_PLATFORM',
  UPDATE_DEVICE_YEAR_CLASS: 'PROFILES_UPDATE_DEVICE_YEAR_CLASS',
  UPDATE_APP_VERSION: 'PROFILES_UPDATE_APP_VERSION',
  UPDATE_BODY_TYPE: 'PROFILES_UPDATE_BODY_TYPE',
  UPDATE_LOGGED_PLANS_COUNT: 'PROFILES_UPDATE_LOGGED_PLANS_COUNT',
  UPDATE_TRAINING_FREQUENCY: 'PROFILES_UPDATE_TRAINING_FREQUENCY',
  UPDATE_AVERAGE_TRAINING_TIME: 'PROFILES_UPDATE_AVERAGE_TRAINING_TIME',
  UPDATE_TOTAL_TIME_TRAINED: 'PROFILES_UPDATE_TOTAL_TIME_TRAINED',
  UPDATE_LOGGED_WORKOUTS_COUNT: 'PROFILES_UPDATE_LOGGED_WORKOUTS_COUNT',
  UPDATE_GYM_ACCESS: 'PROFILES_UPDATE_GYM_ACCESS',
  DELETE_GYM_ACCESS: 'PROFILES_DELETE_GYM_ACCESS',
  UPDATE_WEIGHT_UNIT: 'PROFILES_UPDATE_WEIGHT_UNIT',
  UPDATE_COUNTRY: 'PROFILES_UPDATE_COUNTRY',
  UPDATE_EXPO_PUSH_TOKEN: 'PROFILES_UPDATE_EXPO_PUSH_TOKEN',
  UPDATE_FITNESS_LEVEL: 'PROFILES_UPDATE_FITNESS_LEVEL',
  UPDATE_WEEKLY_WORKOUTS_COUNT_GOAL: 'PROFILES_UPDATE_WEEKLY_WORKOUTS_COUNT_GOAL',
  UPDATE_GENDER: 'PROFILES_UPDATE_GENDER',
  UPDATE_HEIGHT_UNIT: 'PROFILES_UPDATE_HEIGHT_UNIT',
  UPDATE_RATE_US_SHOWED_AT: 'PROFILES_UPDATE_RATE_US_SHOWED_AT',
  UPDATE: 'PROFILES_UPDATE',
  UPDATE_REVIEWED_AT: 'PROFILES_UPDATE_REVIEWED_AT',
  SUGGEST_BODY_TYPE: 'PROFILES_SUGGEST_BODY_TYPE',
  UPDATE_HEIGHT: 'PROFILES_UPDATE_HEIGHT',
  UPDATE_WEIGHT: 'PROFILES_UPDATE_WEIGHT',
  UPDATE_TIMEZONE: 'PROFILES_UPDATE_TIMEZONE',
  UPDATE_GOAL: 'PROFILES_UPDATE_GOAL',
  UPDATE_BIRTHDAY: 'PROFILES_UPDATE_BIRTHDAY',
  SUGGEST_GOAL: 'PROFILES_SUGGEST_GOAL',
  UPDATE_CURRENT: 'PROFILES_UPDATE_CURRENT',
  DELETE_CURRENT: 'PROFILES_DELETE_CURRENT'
}
